import HomeStyle from './home-style';
export default HomeStyle;